import * as SpriteSpin from '../core';
(function () {
    var NAME = 'wheel';
    function wheel(e, data) {
        if (!data.loading && data.stage.is(':visible')) {
            e.preventDefault();
            var we = e.originalEvent;
            var signX = we.deltaX === 0 ? 0 : we.deltaX > 0 ? 1 : -1;
            var signY = we.deltaY === 0 ? 0 : we.deltaY > 0 ? 1 : -1;
            SpriteSpin.updateFrame(data, data.frame + signY, data.lane + signX);
        }
    }
    SpriteSpin.registerPlugin(NAME, {
        name: NAME,
        wheel: wheel
    });
})();
//# sourceMappingURL=input-wheel.js.map